import React from 'react';
import { FmlxDropdown } from 'fmlx-common-ui';
import { ingredientTypesEnum } from './SelectIngredients';

export default function SelectSearch({
  selectValue,
  setSelectValue,
  placeHolder,
  searchValue,
  changeSearch,
}) {
  return (
    <div
      id="selectsearch-wrapper"
      data-testid="selectsearch-wrapper"
      className="flex flex-space-between"
      style={{ padding: '1.45% 4.36%', position: 'sticky' }}
    >
      <input
        id="selectsearch-input"
        data-testid="selectsearch-input"
        type="text"
        placeholder={placeHolder}
        style={{ width: '76.30%', padding: '1.25% 2.34%', height: '2.125%' }}
        onChange={changeSearch}
        value={searchValue}
      />

      <div
        id="selectsearch-dropdown-wrapper"
        data-testid="selectsearch-dropdown-wrapper"
        style={{ width: '22.11%' }}
      >
        <FmlxDropdown
          id="selectsearch-dropdown-list"
          data-testid="selectsearch-dropdown-list"
          items={[
            {
              id: ingredientTypesEnum.All,
              text: 'All',
              group: '',
              disabled: false,
            },
            {
              id: ingredientTypesEnum.Buffer,
              text: 'Buffer',
              group: '',
              disabled: false,
            },
            {
              id: ingredientTypesEnum.NonBuffer,
              text: 'Non Buffer',
              group: '',
              disabled: false,
            },
            {
              id: ingredientTypesEnum.Prepared,
              text: 'Prepared',
              group: '',
              disabled: false,
            },
          ]}
          selectedItem={selectValue}
          onChange={setSelectValue}
          menuProps={{ vertical: 'top', horizontal: 'left' }}
          menuPosition={'top'}
        />
      </div>
    </div>
  );
}
